import React from 'react';
import { IWizardItem } from '../WizardItem';
import WizardVStack from '../WizardVStack/WizardVStack';
import { WizardItemSubType } from '../../../Enums/WizardItemSubtype.enum';

interface Props {
	item: IWizardItem;
}

const WizardContainer: React.FC<Props> = ({ item }) => {
	switch (item.subtype) {
		case WizardItemSubType.V_STACK:
			return <WizardVStack item={item} />;
		default:
			return <>Unsupported container subtype: {item.subtype}</>;
	}
};

export default WizardContainer;
